import { Box, Typography } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { AP_AGING_TOTALS_COLUMNS } from "../constants"
import type { ApAgingTotals } from "../types/apAgingReport"

import { formatCurrencyWithCents } from "@/utils/currency"

interface ApAgingSummaryProps {
  summary: ApAgingTotals
}

// AK-6964 AC4: The aging summary always reflects the filters currently applied.
export const ApAgingSummary: FC<ApAgingSummaryProps> = ({ summary }) => (
  <Box
    className='grid grid-cols-3 divide-x divide-gray-300 overflow-hidden rounded border border-gray-300 xl:grid-cols-6'
    data-testid='ap-aging-report.summary.cards'
  >
    {AP_AGING_TOTALS_COLUMNS.map(({ key, label }) => {
      const isTotal = key === "total"

      return (
        <Box key={key} className='px-4 py-3' data-testid={`ap-aging-report.summary.${key}-card`}>
          <Typography variant='caption' className='whitespace-nowrap text-gray-700'>
            {isTotal ? "Total Outstanding" : label}
          </Typography>
          <Typography
            className={twMerge("whitespace-nowrap text-lg tabular-nums", isTotal && "font-bold")}
            data-testid={`ap-aging-report.summary.${key}-amount`}
          >
            {formatCurrencyWithCents(summary[key])}
          </Typography>
        </Box>
      )
    })}
  </Box>
)
